import React from 'react';
import { AlertTriangle, Shield, Plus } from 'lucide-react';
import { cn } from '@/lib/utils';

type ActionType = 'incomplete' | 'unverified' | 'boost';

interface BoostActionItemProps {
  type: ActionType;
  onClick: () => void;
  hasActiveBoost?: boolean;
  availableBoosts?: number;
}

const actionConfig = {
  incomplete: {
    icon: AlertTriangle,
    label: 'Completar',
    borderColor: 'border-orange-500',
    bgColor: 'bg-orange-500/20',
    iconColor: 'text-orange-500'
  },
  unverified: {
    icon: Shield,
    label: 'Verificar',
    borderColor: 'border-red-500',
    bgColor: 'bg-red-500/20',
    iconColor: 'text-red-500'
  },
  boost: {
    icon: Plus,
    label: 'Boost',
    borderColor: 'border-luxury-pinkBright',
    bgColor: 'bg-luxury-pinkBright/20',
    iconColor: 'text-luxury-pinkBright'
  }
};

export const BoostActionItem: React.FC<BoostActionItemProps> = ({
  type,
  onClick,
  hasActiveBoost = false,
  availableBoosts = 0
}) => {
  const config = actionConfig[type];
  const Icon = config.icon;

  // Se é boost e já tem ativo, mostrar diferente
  const isBoostActive = type === 'boost' && hasActiveBoost;

  return (
    <button
      onClick={onClick}
      className="flex flex-col items-center gap-1 min-w-[60px]"
    >
      <div
        className={cn(
          'w-14 h-14 rounded-full flex items-center justify-center border-2 transition-all',
          isBoostActive 
            ? 'border-green-500 bg-green-500/20' 
            : `${config.borderColor} ${config.bgColor}`,
          'hover:scale-105 active:scale-95'
        )}
      >
        {isBoostActive ? (
          <span className="text-green-500 text-xs font-medium">Ativo</span>
        ) : (
          <Icon className={cn('w-6 h-6', isBoostActive ? 'text-green-500' : config.iconColor)} />
        )}
      </div>
      <span className="text-[10px] text-white/60 truncate max-w-[60px]">
        {isBoostActive ? 'Boost' : config.label}
      </span>
      {type === 'boost' && !hasActiveBoost && availableBoosts > 0 && (
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-luxury-pinkBright rounded-full text-[10px] text-white flex items-center justify-center">
          {availableBoosts}
        </span>
      )}
    </button>
  );
};
